import React, { Component } from 'react';
import ReactHighcharts from '../CommonComponents/Highcharts';
import Tooltip from '../CommonComponents/Tooltip';
import LoadingChart from '../CommonComponents/LoadingChart';
import { Text } from '../CommonComponents/OPL/Text/Text';

export default class RetirementAssetsChartView extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
  }

  load({ fpId, clientId, fetchData, receiveData, data }, showLoading) {
    if (data) {
      receiveData(
        {
          GoalChart: {
            Chart: data,
          },
        },
        clientId,
      );
    } else {
      fetchData(fpId, clientId, showLoading);
    }
  }

  UNSAFE_componentWillMount() {
    this.load(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      newProps.fpId != this.props.fpId ||
      newProps.clientId != this.props.clientId ||
      newProps.data != this.props.data
    ) {
      this.load(newProps, true);
    }
  }

  shouldComponentUpdate(newProps) {
    if (newProps.fpId == this.props.fpId && newProps.clientId == this.props.clientId) {
      if (!ADV.util.shallowEqual(newProps.chartData, this.props.chartData)) {
        return true;
      }
      if (newProps.showLoading != this.props.showLoading) {
        return true;
      }
      if (newProps.proposedPlanName !== this.props.proposedPlanName) {
        return true;
      }
      return false;
    }
    return true;
  }

  render() {
    const {
      chartData,
      noContainer,
      isCurrentPlan,
      loading,
      showLoading,
      proposedPlanName,
      isPrint,
    } = this.props;

    let Content = null;
    if (!chartData && !loading) {
      return null;
    }

    if (showLoading) {
      Content = <LoadingChart />;
    } else if (chartData) {
      Content = (
        <ReactHighcharts
          autoResize
          container="RetirementAssetsChartContainer"
          options={chartData}
        />
      );
    } else {
      Content = <LoadingChart />;
    }

    if (noContainer) {
      return <section className="RetirementAssetsChart">{Content}</section>;
    }

    return (
      <section className={`RetirementAssetsChart with-container${isPrint ? ' is-print' : ''}`}>
        <Text
          fontSize="h6"
          color="info.500"
          display="inline-block"
          width="50%"
          style={{ lineHeight: '80px' }}
        >
          Retirement Assets
        </Text>
        <ul className="legend hide-on-mobile-screens">
          {!isCurrentPlan && (
            <Tooltip
              tag="li"
              tooltipchildren={ADV.tooltip_callouts.RetirementAssetsChart.Current.html}
              orientation={ADV.tooltip_callouts.RetirementAssetsChart.Current.orientation}
            >
              <i />
              Current
            </Tooltip>
          )}
          {!isCurrentPlan && (
            <Tooltip
              tag="li"
              className="proposed-plan"
              tooltipchildren={ADV.tooltip_callouts.RetirementAssetsChart.ProposedPlan.html}
              orientation={ADV.tooltip_callouts.RetirementAssetsChart.ProposedPlan.orientation}
            >
              <i className="stripe-transparent" />
              {proposedPlanName}
            </Tooltip>
          )}
        </ul>
        {Content}
      </section>
    );
  }
}
